import * as Yup from 'yup'
import i18n from 'i18n'

export const PartnerFormSchema = Yup.object().shape({
  partnerName: Yup.string().required().label(i18n.t('partner:basicInformation'))
})
export type PartnerFormYup = Yup.InferType<typeof PartnerFormSchema>
